import { type ComputedRef, onMounted, onUnmounted, watch } from "vue";
import { useAppStore } from "@/stores/app";

export function useConfirmChanges(
  wasChanges: ComputedRef<boolean>,
  textForConfirm?: string,
) {
  const appStore = useAppStore();

  watch(
    () => wasChanges.value,
    (newValue) => {
      if (newValue) {
        appStore.setNotSavedChanges(textForConfirm);
      } else {
        appStore.resetNotSavedChanges();
      }
    },
    { deep: true },
  );

  const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    if (wasChanges.value) {
      event.preventDefault();
      event.returnValue = "";
    }
  };

  onMounted(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);
  });

  onUnmounted(() => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
  });

  return {};
}
